import anchorme from "anchorme"

export const unicodeToChar = text => {
  return text.replace(/\\u[\dA-F]{4}/gi, function(match) {
    return String.fromCharCode(parseInt(match.replace(/\\u/g, ""), 16))
  })
}

export const transformCloudUrl = url => {
  if (url.includes("www.dropbox.com")) {
    return url.replace("www.dropbox.com", "dl.dropbox.com")
  } else if (url.includes("drive.google.com")) {
    let matches = url.match(/\/file\/d\/([^\/]+)\//) || []
    if (matches.length > 0) {
      return `https://drive.google.com/uc?export=view&id=${matches[1]}`
    }
  } else {
    return url
  }
}

export const stripText = str => {
  // @[@avse](/b/avse) and The Deli posted a rad writeup of our split 7" with @[@kissedbyananimal](/b/kissedbyananimal)
  return str.replace(/\([^\)]+\)/gi, "").replace(/@+\[@?([^\]]+)\]/gi, "@$1")
}

const MENTION_REGEX = /@+\[@?([^\]]+)\]\(([^)]+)\)/g
const MENTION_CAPTURE_REGEX = /@+\[@?([^\]]+)\]\(([^)]+)\)/
const MENTION_PLACEHOLDER_PREFIX = "<<<BN_MENTION_"
const MENTION_PLACEHOLDER_SUFFIX = ">>>"

const mentionLinkHtml = (username, path) => {
  const functionalPath = /^\//.test(path) ? path : "#"
  return `<a class="font-bold text-green-700" href="${functionalPath}">@${username}</a>`
}

// Pulls @[@handle](path) mention markup out of `text` into placeholder
// tokens, so callers that run their own text processing (e.g. FreeTextFormat's
// stripLinks, which strips markdown-style [text](url) links generically and
// would otherwise mangle mention markup into a stray leading "@") can do so
// without corrupting mentions. Pair with unmaskMentions to splice the real
// link HTML back in afterward.
export const maskMentions = text => {
  if (!text) return [text, []]
  const placeholders = []
  const masked = text.replace(MENTION_REGEX, str => {
    const [, username, path] = MENTION_CAPTURE_REGEX.exec(str)
    placeholders.push(mentionLinkHtml(username, path))
    return `${MENTION_PLACEHOLDER_PREFIX}${placeholders.length - 1}${MENTION_PLACEHOLDER_SUFFIX}`
  })
  return [masked, placeholders]
}

export const unmaskMentions = (text, placeholders) => {
  let result = text
  placeholders.forEach((html, index) => {
    result = result.replace(
      `${MENTION_PLACEHOLDER_PREFIX}${index}${MENTION_PLACEHOLDER_SUFFIX}`,
      html,
    )
  })
  return result
}

export const anchormeBandNada = (message, stylize = true) => {
  const bgImage =
    "https://bandnada.s3.amazonaws.com/static/external_assets/web/bandnada_dysentery.png"
  return anchorme({
    input: message,
    options: {
      attributes: {
        target: "_blank",
        class: stylize
          ? "text-blue-600 hover:text-gray-600 text-sm cursor-pointer"
          : "",
      },
      truncate: 40,
      middleTruncation: true,
      specialTransform: [
        {
          test: /(drive\.google\.com)/i,
          transform: s => {
            const url = transformCloudUrl(s)
            return `<img style="max-height:416px;" class="my-2" src="${url}" onerror="vidEl = document.createElement('video'); vidEl.style='${
              stylize ? "max-height:416px;width:100%" : ""
            }'; vidEl.controls='true'; vidEl.class='my-2'; srcEl=document.createElement('source'); srcEl.src='${url}'; srcEl.type='video/mp4'; vidEl.appendChild(srcEl);this.after(vidEl); this.remove();"/>`
          },
        },
        {
          test: /(.*\.(png|jpg|gif|jpeg)(\?|$))/i,
          transform: s => {
            const url = transformCloudUrl(s)
            return `<img style="max-height:416px;" class="my-2" src="${url}" onerror="newEl=createElement('span');newEl.innerText='(image missing)';newEl.style='font-style:italic;color:#777;';this.after(newEl);this.remove();"/>`
          },
        },
        {
          test: /.*\.(mp4)(\?|$)/,
          transform: s => {
            const url = transformCloudUrl(s)
            return `<video style="max-height:416px;" class="my-2" width="100%" controls="true" poster="${bgImage}"><source src="${url}" type="video/mp4"></video>`
          },
        },
        {
          test: /youtube\.com\/watch\?v\=/,
          transform: str => {
            const videoId = str.replace(/.*watch\?v=([^&]*).*/, "$1")
            return `<iframe style="width:100%;aspect-ratio:16/9;" src="https://www.youtube.com/embed/${videoId}"/>`
          },
        },
        {
          test: /youtube\.com\/shorts\//,
          transform: str => {
            const videoId = str.replace(/.*youtube\.com\/shorts\/([^/?&]+).*/, "$1")
            return `<iframe style="width:100%;aspect-ratio:16/9;" src="https://www.youtube.com/embed/${videoId}"/>`
          },
        },
      ],
    },
    extensions: [
      // chat commands meta
      {
        test: /(\~\$\$\~[^\~]+\~\$\$\~)/gi,
        transform: s => `<span class="text-xs text-gray-500">${s}</span>`,
      },
      // Hashtags
      {
        test: /(^href)#(\w|_)+/gi,
        transform: string =>
          `<span class="font-bold text-green-600">${string}</span>`,
      },
      {
        test: MENTION_REGEX,
        transform: str => {
          const [, username, path] = MENTION_CAPTURE_REGEX.exec(str)
          return mentionLinkHtml(username, path)
        },
      },
    ],
  })
}
